"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (el) {
  return {
    top: el.getBoundingClientRect().top + document.body.scrollTop,
    left: el.getBoundingClientRect().left + document.body.scrollLeft
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplayer-utils/lib/getElementOffset.js
// module id = 763
// module chunks = 0